<template>
  <v-container class="fill-height align-start">
    <v-row no-gutters>
      <v-col cols="6">
        <ws-type-selector v-model="selectedFT" :set-global-filter="true" class="mr-2 fill-height"/>
      </v-col>
      <v-col cols="6">
        <wsStatusSelector v-model="selectedDS" :set-global-filter="true" class="mr-2 fill-height"/>
      </v-col>
      <v-col cols="12">
        <receptures-table v-model="currentRecepture" />
      </v-col>
    </v-row>
    <prj-action-dialog :project ="currentRecepture[0]" v-model="showChangeStatusDialog"></prj-action-dialog>
  </v-container>
</template>
<script>
import wsStatusSelector from '@/components/modules/projects/ui/wsStatusSelect.vue'
import WsTypeSelector from '@/components/modules/projects/ui/wsTypeSelector'
import RecepturesTable from '@/components/modules/projects/ui/tblRecepturesTable'
import { RCPT_SET_CURRENT } from '@/store/actions/receptures'

import {
  UI_ADD_ACTION,
  UI_DEL_ACTION,
  UI_SET_ACTIONS
  /*, UI_SNACKBAR */
} from '@/store/actions/ui'
import PrjActionDialog from '@/components/modules/projects/dialogs/prjActionDialog'

export default {
  name: 'configListView',
  components: {
    PrjActionDialog,
    WsTypeSelector,
    RecepturesTable,
    wsStatusSelector
  },
  data () {
    return {
      localFT: null,
      localDS: null,
      localComponent: {},
      rcptAvlStatuses: [],
      showChangeStatusDialog: false,
      localProperty: undefined,
      addAction: { text: 'Новая конфигурация', actionType: 'Конфигурация', action: 'addNewConfig', method: this.addConfig, icon: 'mdi-plus', params: '' },
      viewAction: { text: 'Просмотр', actionType: 'Конфигурация', action: 'viewConfig', method: this.viewConfig, icon: 'mdi-magnify', params: '' },
      postAction: { text: 'Изменить статус', actionType: 'Управление состоянием', action: 'postConfig', method: this.postConfig, icon: 'mdi-cube-send', params: '' }
    }
  },
  computed: {
    selectedFT: {
      get: function () {
        return this.$store.getters.getCurrentRecepturesTypeFilter
      },
      set: function (val) {
        this.localFT = val
      }
    },
    selectedDS: {
      get: function () {
        return this.$store.getters.getCurrentRecepturesStateFilter
      },
      set: function (val) {
        this.localDS = val
      }
    },
    currentRecepture: {
      get: function () {
        const ret = this.$store.getters.getCurrentRecepture.ULF_ID ? [this.$store.getters.getCurrentRecepture] : []
        console.log('myProjects: getting current recepture ', ret)
        return ret
      },
      set: function (val) {
        console.log('myProjects: setting current recepture ', val)
        this.$store.dispatch(RCPT_SET_CURRENT, val.length > 0 ? val[0] : {})
      }
    },
    currentComponent: {
      get: function () {
        return this.localComponent.CMP_ID ? [this.localComponent] : []
      },
      set: function (val) {
        this.localComponent = val.length > 0 ? val[0] : {}
      }
    },
    currentProperty: {
      get: function () {
        return this.localProperty
      },
      set: function (val) {
        this.localProperty = val
      }
    }
  },
  mounted: function () {
    console.log('views::myProjects index mounted')
    this.setActions()
  },
  watch: {
    async currentRecepture () {
      this.setActions()
    }
  },
  methods: {
    setActions () {
      console.log('myProjects setting actions')
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Конфигурация', actions: [] })
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Управление состоянием', actions: [] })
      // const self = this
      this.$store.dispatch(UI_ADD_ACTION, this.addAction)
      if (!this.currentRecepture.length) { return }
      if (this.currentRecepture[0].ULF_ID) {
        this.$store.dispatch(UI_ADD_ACTION, this.viewAction)
        this.$store.dispatch(UI_ADD_ACTION, this.postAction)
      } else {
        this.$store.dispatch(UI_DEL_ACTION, this.viewAction)
      }
    },
    addConfig () {
      console.log('Trying to add recepture')
      this.$store.dispatch(RCPT_SET_CURRENT, {})
      this.$router.push({ path: '/projects/project' })
    },
    postConfig () {
      console.log('Trying to change recepture state')
      this.showChangeStatusDialog = true
    },
    viewConfig () {
      console.log('Trying to view recepture', this.currentRecepture[0])
      this.$router.push({ path: '/projects/project' })
    }
  }
}
</script>
